var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55572e-08 2.48207C1.42278e-08 0.938492 1.67443 -0.0232497 3.00774 0.754516L9.03848 4.27244C10.3615 5.0442 10.3615 6.9558 9.03847 7.72756L3.00774 11.2455C1.67443 12.0233 8.85272e-08 11.0615 7.71979e-08 9.51793L2.55572e-08 2.48207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAudio);
export default __webpack_public_path__ + "static/media/playAudio.ce617ad4ce0ebbd712407f5877c32443.svg";
export { ForwardRef as ReactComponent };